import { addToCartTagging } from 'global/tagging/globalTaggingEvents';
import addToCartVariantStatus from 'global/addToCart/addToCartVariantStatus';
import { GtmTrackingType } from '../constants';

export const getAddToCartTaggingData = modalHtml => {
	// TODO Data comes from server so needs to be called something more generic like signalData.tag
	const signalDiv = modalHtml.querySelector('[data-signal]');
	const signalString = signalDiv ? signalDiv.textContent : '{}';
	let signalJson;

	try {
		signalJson = JSON.parse(signalString);
	} catch (jsonError) {
		signalJson = {};
	}

	// Add additional boolean determining whether referral page is a product variant page
	try {
		const { pageType, pageReferer, variants } =
			window.od.journeyData.navigation;

		if (pageType === 'product') {
			signalJson.navigation.isRefererVariant = addToCartVariantStatus({
				pageType,
				pageReferer,
				variants,
			});
		}
	} catch (error) {
		if (console) console.error(error); // eslint-disable-line no-console
	}

	window.od.events.publish(GtmTrackingType.ADD_TO_BASKET, signalJson);

	return signalJson;
};

export const trackAddToCartTaggingData = modalHtml => {
	const taggingData = getAddToCartTaggingData(modalHtml);
	addToCartTagging(taggingData);

	return taggingData;
};
